import React from 'react'
import { Link } from 'react-router-dom'

import { ReactComponent as Bank } from '../assets/icons/bank.svg'
import { ReactComponent as Cart } from '../assets/icons/cart.svg'
import { ReactComponent as Package } from '../assets/icons/package.svg'
import { ReactComponent as Quote } from '../assets/icons/quote.svg'

import "./Home.css"
import { useTranslate } from '../Context/LanguageContext'
import Seperator from '../Util/Seperator'
import Counter from './Counter'
import Button from '../Util/Button'

const Home = () => {
    const t = useTranslate("home")

    return (
        <div className='home'>
            <div id='image'>
                <img
                    src='./images/shanghai.webp'
                    alt='Shanghai Skyline'
                    loading='eager'
                    decoding='async'
                />
                <span className='overlay' aria-hidden='true' />
            </div>

            <section className='heading'>
                <div className='wrapper'>
                    <h2 className='eyebrow'>
                        <span className='bar' aria-hidden='true' />
                        SINIS
                    </h2>
                    <h1>China <br /> Consulting</h1>
                </div>

                <div className='scroll-hint' aria-hidden='true'>
                    <span className='mouse'>
                        <span className='wheel' />
                    </span>
                </div>
            </section>

            <section className='quote'>
                <div className='wrapper'>
                    <Quote aria-hidden='true' />
                    <p className='promise'> {t("quote")} </p>
                    <p className='author'> SINIS GmbH </p>
                    <div className='links'>
                        <Button to="/about" filled> {t("more")} </Button>
                        <Button to="/contact"> {t("contact")} </Button>
                    </div>
                </div>

                <Seperator />
            </section>

            <section className='offers'>
                <div className='container'>
                    <p className='intro'> {t("consulting")} </p>

                    <div className='wrapper'>
                        <Link className='offer' to="/invest">
                            <Bank aria-hidden='true' />
                            <h3> {t("invest")} </h3>
                            <h4> {t("invest-desc1")} <br /> {t("invest-desc2")}</h4>
                            <div className='more'>
                                <span aria-hidden='true' />
                                <p>{t("more")} →</p>
                            </div>
                        </Link>

                        <Link className='offer' to="/purchase">
                            <Cart aria-hidden='true' />
                            <h3> {t("purchase")} </h3>
                            <h4> {t("purchase-desc1")} <br /> {t("purchase-desc2")}</h4>
                            <div className='more'>
                                <span aria-hidden='true' />
                                <p>{t("more")} →</p>
                            </div>
                        </Link>

                        <Link className='offer' to="/distribution">
                            <Package aria-hidden='true' />
                            <h3> {t("distribution")} </h3>
                            <h4> {t("distribution-desc1")} <br /> {t("distribution-desc2")}</h4>
                            <div className='more'>
                                <span aria-hidden='true' />
                                <p>{t("more")} →</p>
                            </div>
                        </Link>
                    </div>
                </div>

                <Seperator />
            </section>

            <section className='courses'>
                <div className='container'>

                    <p className='intro'> {t("courses")} </p>

                    <div
                        className='slider scrollbar-x'
                        role='region'
                        aria-label={t("courses")}
                        tabIndex={0}
                    >

                        <div className='course' tabIndex={0}>
                            <img
                                src='./images/intercultural-management.webp'
                                alt={t("intercultural")}
                                loading='lazy'
                                decoding='async'
                            />
                            <span className='overlay' aria-hidden='true' />
                            <h3 className='title'> {t("intercultural")} </h3>
                            <div className='description'>
                                <p>{t("intercultural-desc")}</p>
                                <Link to="/contact">{t("request")} →</Link>
                            </div>
                        </div>

                        <div className='course' tabIndex={0}>
                            <img
                                src='./images/preperation-for-your-china-trip.webp'
                                alt={t("preperation")}
                                loading='lazy'
                                decoding='async'
                            />
                            <span className='overlay' aria-hidden='true' />
                            <h3 className='title'> {t("preperation")} </h3>
                            <div className='description'>
                                <p> {t("preperation-desc")} </p>
                                <Link to="/contact">{t("request")} →</Link>
                            </div>
                        </div>

                        <div className='course' tabIndex={0}>
                            <img
                                src='./images/strategic-purchasing-in-china.webp'
                                alt={t("purchasing")}
                                loading='lazy'
                                decoding='async'
                            />
                            <span className='overlay' aria-hidden='true' />
                            <h3 className='title'> {t("purchasing")} </h3>
                            <div className='description'>
                                <p> {t("purchasing-desc")} </p>
                                <Link to="/contact">{t("request")} →</Link>
                            </div>
                        </div>

                        <div className='course' tabIndex={0}>
                            <img
                                src='./images/negotiating-with-chinese-business-partners.webp'
                                alt={t("negotiating")}
                                loading='lazy'
                                decoding='async'
                            />
                            <span className='overlay' aria-hidden='true' />
                            <h3 className='title'> {t("negotiating")} </h3>
                            <div className='description'>
                                <p> {t("negotiating-desc")} </p>
                                <Link to="/contact">{t("request")} →</Link>
                            </div>
                        </div>

                    </div>

                </div>

                <Seperator />
            </section>

            <section className='recruitment'>

                <div className='wrapper'>
                    <div className='counter-wrapper'>
                        <Counter />
                        <p>{t("missing")}</p>
                    </div>

                    <div className='text-wrapper'>
                        <p>{t("recruitment")}</p>
                    </div>

                    <Button to="/recruitment" filled> {t("more")} </Button>
                </div>

                <Seperator />
            </section>

            <section className='partner'>
                <div className='container'>
                    <Link to={"/contact"} className='wrapper'>
                        <div className='img-wrapper'>
                            <h2> {t("partner1")} <br /> {t("partner2")}</h2>
                            <img
                                src='./images/partner.webp'
                                alt={`${t("partner1")} ${t("partner2")}`}
                                loading='lazy'
                                decoding='async'
                            />
                        </div>
                    </Link>

                    <span className='line' aria-hidden='true' />

                    <div className='text'>
                        <p> {t("partner-desc1")} </p>
                        <p> {t("partner-desc2")} </p>
                        <Button to="/contact"> {t("contact")} </Button>
                    </div>
                </div>
            </section>

        </div>
    );
}

export default Home;